import React, { useState, useEffect, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import { useOrderStatus } from 'query/hooks';

import { Loader } from 'components';

import { WarningIcon } from 'icons';

import Adyen3dCard from '../containers/payment/adyen-credit-card/credit-card';
import messages from 'messages';

function Payment({ ...props }) {
    const { formatMessage } = props.intl;
    const history = useHistory();
    const { order } = props.match.params;

    const purchaseMutation = useMutation('purchase-mutation');

    const purchase = useQuery('purchase')?.data || {};
    const orderStatus = useOrderStatus(order)?.data || {};

    const { domain } = useQuery('restaurant')?.data || {};

    const [initialLoading, setInitialLoading] = useState(true);

    const [processing, setProcessing] = useState(false);
    const [apiError, setApiError] = useState({
        key: '',
        hasError: false,
        message: '',
    });

    const id = props.match.params.order;

    const purchaseGiftCard = (paymentMethod = null) => {
        if (paymentMethod.type) {
            setProcessing(true);
            setApiError({ key: '', hasError: false, message: '' });

            const data = {
                order,
                paymentData: paymentMethod,
            };

            purchaseMutation.mutate(data);
        }
    };

    const handleServerResponse = (response) => {
        setProcessing(false);
        setApiError({ key: '', hasError: false, message: '' });

        if (response.error) {
        } else if (response.requires_action) {
            handleAction(response);
        } else {
            setProcessing(false);
            history.push(`/${domain}/thankyou`);
        }
    };

    const handleAction = (data) => {
        const { url, method, data: redirectData } = data.data.redirect;

        if (method === 'GET') {
            return (window.location = url);
        }

        const createHidden = (name, value) => {
            const el = document.createElement('input');
            el.setAttribute('type', 'hidden');
            el.setAttribute('name', name);
            el.setAttribute('value', value);
            return el;
        };

        const authForm = document.createElement('form');
        authForm.action = url;
        authForm.method = method;

        const { MD, PaReq, TermUrl } = redirectData;
        authForm.appendChild(createHidden('MD', MD));
        authForm.appendChild(createHidden('PaReq', PaReq));
        authForm.appendChild(createHidden('TermUrl', TermUrl));
        document.body.appendChild(authForm);

        return authForm.submit();
    };

    const handleOrderSituation = () => {
        history.push(`/${domain}/thankyou`);
    };

    useEffect(() => {
        setInitialLoading(false);
    }, [id]);

    useEffect(() => {
        if (purchase.id) {
            handleServerResponse(purchase);
        }

        if (orderStatus.status === 'paid') {
            handleOrderSituation();
        }

        if (purchase.error === true) {
            setApiError({ key: '', hasError: true, message: '' });
            setProcessing(false);
        }
    }, [purchase.id, orderStatus.status, purchase.error, purchase]);

    return (
        <div className="page-wrapper page-payment">
            {initialLoading ? (
                <Loader />
            ) : (
                <Fragment>
                    <h2 className="title">{formatMessage(messages.paymentTitle)}</h2>

                    <Adyen3dCard
                        callback={(data) => purchaseGiftCard(data)}
                        apiError={apiError}
                        apiProcessing={processing}
                    />
                    {apiError.hasError}

                    {apiError?.hasError === true && (
                        <p className="error">
                            <WarningIcon size={16} />
                            {formatMessage(messages.errorGeneric)}
                        </p>
                    )}
                </Fragment>
            )}
        </div>
    );
}

export default injectIntl(React.memo(Payment));
